import createLucideIcon from '../createLucideIcon';

const Dice1 = createLucideIcon('Dice1Icon', [
  [
    'rect',
    {
      x: '3',
      y: '3',
      width: '18',
      height: '18',
      rx: '2',
      ry: '2',
      key: 'maln0c',
    },
  ],
  ['path', { d: 'M12 12h.01', key: '1mp3jc' }],
]);

export default Dice1;
